import { render, staticRenderFns } from "./SingleGame.vue?vue&type=template&id=25aa951a"
import script from "./SingleGame.vue?vue&type=script&lang=js"
export * from "./SingleGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports